// extracted by mini-css-extract-plugin
export var Banner = "style-module--Banner--a785c";
export var Card = "style-module--Card--a206e";
export var Category = "style-module--Category--c57e3";
export var DescriptionWrapper = "style-module--DescriptionWrapper--7c2e0";
export var Details = "style-module--Details--f77d2";
export var Image = "style-module--Image--dfa49";
export var ImageWrapper = "style-module--ImageWrapper--8302a";
export var ReadingTime = "style-module--ReadingTime--04877";
export var Title = "style-module--Title--2ffc2";